export default function WhoWeServe() {
  return (
    <section className="py-32 px-8 bg-[#0A0A0A]">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div className="space-y-8 order-2 md:order-1">
            <div className="inline-flex items-center gap-2 border border-white/20 rounded-full px-5 py-2">
              <span className="text-xs font-bold text-white tracking-wide">FOR EVERYONE</span>
            </div>

            <h2 className="text-5xl md:text-6xl lg:text-7xl font-black text-white leading-[0.95] tracking-tight">
              Ages 5 to 70.<br />
              No Limits.
            </h2>

            <div className="space-y-6 text-lg text-gray-300 leading-relaxed">
              <p>
                <strong className="text-white font-bold">BillPlay serves everyone.</strong> From kids finding their style to adults who never lost theirs. We blend streetwear influence with comfort, versatility, and statement design.
              </p>
              
              <p>
                Our pieces are for people who want <strong className="text-white font-bold">confidence, individuality, and style with purpose.</strong> Whether you're stepping out, staying in, or making moves—BillPlay fits your life.
              </p>

              <p className="text-white font-bold text-xl">
                Real style. Real people. Real culture.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-8 pt-8 border-t border-white/10">
              <div>
                <div className="text-4xl font-black text-white mb-2">5-70</div>
                <div className="text-sm text-gray-400">Age Range</div>
              </div>
              <div>
                <div className="text-4xl font-black text-white mb-2">2017</div>
                <div className="text-sm text-gray-400">Founded</div>
              </div>
              <div>
                <div className="text-4xl font-black text-white mb-2">100%</div>
                <div className="text-sm text-gray-400">Authentic</div>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative h-[600px] rounded-2xl overflow-hidden order-1 md:order-2">
            <img
              src="https://public.readdy.ai/ai/img_res/83edd116e738d3bc1db183405083992c.jpg"
              alt="BillPlay Community"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
          </div>
        </div>
      </div>
    </section>
  );
}